export default __webpack_public_path__ + "static/media/gengarTexture.eb10a1ef.jpg";